import React from 'react';

const Loader = () => {
  return (
    <div className="flex justify-center items-center h-screen w-full">
      <div className="w-12 h-12 border-4 border-dashed rounded-full animate-spin border-orange-primary"></div>
    </div>
  );
};

export default Loader;
